/**
 * Ermittelt die customerId für eine Daten-Anforderung.
 * Ist ein Resolver gesetzt (legt z. B. den Kunden an / speichert die E-Mail am
 * Kunden), gewinnt dessen Rückgabe; sonst wird die übergebene customerId genutzt.
 */
export async function resolveInviteCustomerId(
  email: string,
  customerId: number | undefined,
  onResolveCustomerId?: (email: string) => Promise<number | undefined>,
): Promise<number | undefined> {
  if (onResolveCustomerId) return onResolveCustomerId(email);
  return customerId;
}
